import { render, staticRenderFns } from "./ViewPlotDetails900.vue?vue&type=template&id=d15ba656"
import script from "./ViewPlotDetails900.vue?vue&type=script&lang=ts"
export * from "./ViewPlotDetails900.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports